import {Plugin, PluginKey} from 'prosemirror-state';
import {Decoration, DecorationSet} from 'prosemirror-view';
import {dataTransferFiles} from '../helper/dataTransferFiles';
import 'fomantic-ui-less/definitions/modules/progress';
import {uploadFile} from '../helper/file';

export const fileDropHandlerKey = new PluginKey('fileDropHandler');

export const fileDropHandler = url => new Plugin({
    key: fileDropHandlerKey,
    state: {
        init() {
            return DecorationSet.empty;
        }, apply(tr, decorationSet) {
            decorationSet = decorationSet.map(tr.mapping, tr.doc);
            const action = tr.getMeta(this);
            if (action && action.add) {
                const widget = document.createElement("div");
                widget.className = 'ui active inline slow loader tiny upload';
                const decoration = Decoration.widget(action.add.pos, widget, {id: action.add.id});
                decorationSet = decorationSet.add(tr.doc, [decoration]);
            } else if (action && action.remove) {
                decorationSet = decorationSet.remove(decorationSet.find(null, null, spec => spec.id === action.remove.id));
            }
            return decorationSet;
        }
    },
    props: {
        decorations(state) {
            return this.getState(state);
        },
        handleDOMEvents: {
            paste: (view, event) => {
                if (!view.editable) {
                    return false;
                }

                if (!event.clipboardData) {
                    return false;
                }

                const files = Array.prototype.slice
                    .call(event.clipboardData.items)
                    .map(dt => dt.getAsFile())
                    .filter(file => file != null);
                if (files.length === 0) {
                    return false;
                }

                event.stopPropagation();
                event.preventDefault();

                [...files].forEach(file => uploadFile(url, file, view));

                return true;
            },
            drop: (view, event) => {
                if (!view.editable) {
                    return false;
                }

                const files = dataTransferFiles(event);
                if (files.length === 0) {
                    return false;
                }

                event.stopPropagation();
                event.preventDefault();

                [...files].forEach(file => uploadFile(url, file, view));

                return true;
            }
        }
    }
});